import { empresaDeCuenta } from 'src/app/pipes/empresa-cuenta.pipe';

export type PerfilContrato = 'MT' | 'CT';

const NOMBRE: Record<PerfilContrato, string> = { MT: 'Mundo Total', CT: 'CrediTotal' };

/** Perfil de la cuenta: 'CT' si lo dice (perfil o empresa); sin perfil es MT. */
export function perfilDeCuenta(cuenta: any): PerfilContrato {
  return empresaDeCuenta(cuenta) === 'CrediTotal' ? 'CT' : 'MT';
}

/**
 * Aviso para el analista que elige una cuenta de un contrato distinto al activo
 * (separación de contratos MT/CT). null si coincide o si no se sabe el perfil activo.
 */
export function avisoCuentaContrato(cuenta: any, perfilActivo: string | null | undefined): string | null {
  const activo = String(perfilActivo ?? '').trim().toUpperCase();
  if (!cuenta || (activo !== 'MT' && activo !== 'CT')) return null;
  const propio = perfilDeCuenta(cuenta);
  if (propio === activo) return null;
  const nombre = NOMBRE[propio];
  const nombreActivo = NOMBRE[activo as PerfilContrato];
  if (propio === 'MT') {
    return `Esta cuenta es de ${nombre}, el contrato anterior. Úsala solo para registrar pagos que el cliente hizo antes del cambio a ${nombreActivo}. El pago se verificará en el contrato de ${nombre}.`;
  }
  return `Esta cuenta es de ${nombre}, que todavía no es el contrato activo. El pago se verificará en el contrato de ${nombre}.`;
}
